import { Box, SxProps, Theme } from '@mui/material'
import React from 'react'
import WizardSvg from '../svg/wizard.svg'

export interface WizardProps {
  waiting: true
  sx?: SxProps<Theme>
}

export function Wizard(props: WizardProps): React.ReactElement {

  const { sx } = props

  return (
    <Box sx={{ ...sx, position: 'relative', height: '14rem', width: '14rem' }}>
      <img src={WizardSvg} style={{ height: '14rem', userSelect: 'none' }} alt="Enion wizard"/>
      <Box className="rotating" sx={{
        position: 'absolute',
        left: '0',
        top: '2.2rem',
        borderTop: '5px solid white',
        borderLeft: '5px solid gray',
        borderRight: '5px solid gray',
        borderBottom: '5px solid gray',
        width: '3.42rem',
        height: '3.42rem',
        borderRadius: '1.71rem'
      }}/>
    </Box>
  )
}
